
import { defineComponent, Ref, ref } from "vue";
import StatusBlock from "./StatusBlock.vue";
import LoadingModal from "./LoadingModal.vue";
import LoginFormContainer from "./LoginFormContainer.vue";
import RecaptchaBlock from "./RecaptchaBlock.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { States, submitHandler } from "./submit_handler";
import { useRouter } from "vue-router";
import { useConfigStore } from "@/store/config";
import { useAuthStore } from "@/store/auth";

export default defineComponent({
  components: {
    LoginFormContainer,
    StatusBlock,
    LoadingModal,
    Form,
    Field,
    ErrorMessage,
    RecaptchaBlock
  },
  setup() {
    const auth = useAuthStore();
    const config = useConfigStore();
    const router = useRouter();
    let states: States = {
      recaptcha: ref(null),
      loadingShow: ref(false),
      errorMessage: ref(""),
      captchaEnabled: config.captcha.validateCaptchaForLogin
    };

    let credentials = ref({
      username: "",
      password: ""
    });

    function signIn() {
      submitHandler(
        auth.login({
          username: credentials.value.username,
          password: credentials.value.password,
          ...(states.captchaEnabled ? { captcha: (states.recaptcha as Ref<typeof RecaptchaBlock>)?.value?.token() } : {})
        }),
        states,
        () => { //success handler
          router.push("dashboard");
        }
      );
    }

    return {
      loadingShow: states.loadingShow,
      captchaEnabled: states.captchaEnabled,
      errorMessage: states.errorMessage,
      recaptcha: states.recaptcha,
      credentials,
      signIn
    };
  }
});
